import { getElementPositionInPageContext } from "../utils";
import { Cinema } from "../cinema-module/cinema";
import { benefitBounce } from "@otto-ec/nexus-registry/benefit/bounce";
import { createLogger } from "utils/logging";

const log = createLogger("cinema", "bounce");

benefitBounce.init.subscribe(() => {
	log.info("Initialize BounceCinema");

	const root = document.getElementById("ft9_benefit_cinema__root_marker");
	const featureOrder = getElementPositionInPageContext(root, "feature-order");

	new Cinema().init(featureOrder);
});
